export const inr = (n) =>
  `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const formatDate = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        timeZone: "Asia/Kolkata",
      })
    : "—";

export const formatDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Asia/Kolkata",
      })
    : "—";

export const PURPOSE_LABELS = {
  BOOKING_PAYMENT: "Booking payment",
  EMPLOYEE_CASH_DEPOSIT: "Professional cash deposit",
  OTHER: "Other",
};

export const SUGGESTION_LABELS = {
  BOOKING_PAYMENT: "Booking payment",
  EMPLOYEE_CASH_DEPOSIT: "Professional cash deposit",
  TEST: "Test payment",
};

export const STATUS_STYLES = {
  CREATED: "bg-blue-100 text-blue-700",
  PAID: "bg-green-100 text-green-700",
  EXPIRED: "bg-gray-100 text-gray-600",
  CANCELLED: "bg-gray-100 text-gray-600",
  NEEDS_REVIEW: "bg-red-100 text-red-700",
  UNLINKED: "bg-amber-100 text-amber-800",
  LINKED_BOOKING: "bg-green-100 text-green-700",
  LINKED_EMPLOYEE_DEPOSIT: "bg-green-100 text-green-700",
  OTHER_INCOME: "bg-green-100 text-green-700",
  IGNORED: "bg-gray-100 text-gray-600",
};

export const statusLabel = (s) => (s || "").toLowerCase().replace(/_/g, " ");
